import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TabItemList from '../common/tabItemList';
import Permissions from '../../services/enums/permissions';

@inject('routesStore', 'oidcStore', 'configurationsStore') @observer
class PortalTabs extends Component {

    componentDidMount() {
        this.props.configurationsStore.updateStore();
    }

    isStacOrDefaultTenant() {
        const { isMultitenancyMode, isDefaultTenant } = this.props.configurationsStore;
        return isMultitenancyMode === false || isDefaultTenant;
    }

    getDefaultSettingsUrl() {
        const { isMultitenancyMode } = this.props.configurationsStore;

        if (this.getUserPermissions() && this.getUserPermissions().includes(Permissions.manageSystemSettings) && this.isStacOrDefaultTenant())
            return '/settings/general';

        return isMultitenancyMode
            ? '/settings/saml'
            : '/settings/ldap'
    }

    getUserPermissions = () => this.props.oidcStore.currentUser.profile['access-control-permissions'];

    render() {

        var settingTabIndex = this.props.routesStore.tabs.findIndex(t => t.routeId == 3);
        this.props.routesStore.tabs[settingTabIndex].url = this.getDefaultSettingsUrl();

        return (
            <TabItemList cssClass='header-nav-tabs' tabs={this.props.routesStore.tabs} />
        );
    }
}

export default PortalTabs;


// WEBPACK FOOTER //
// ./src/components/portal/portalTabs.jsx